import React from 'react';
import { GoldPlaque } from './GoldPlaque';
type SectionHeadingProps = {
  id: string;
  eyebrow: string;
  lead: string;
  highlight: string;
  intro?: string;
  tone?: 'dark' | 'light';
};
export function SectionHeading({
  id,
  eyebrow,
  lead,
  highlight,
  intro,
  tone = 'light'
}: SectionHeadingProps) {
  return <div className="mx-auto max-w-3xl text-center" data-id="element-625" data-mp="rwpz2k9mlnj3">
      <GoldPlaque tone={tone} data-id="element-626" data-mp="s043dy1uo6t6">{eyebrow}</GoldPlaque>
      <h2 id={id} className="mt-6 font-display text-[38px] font-bold uppercase leading-[0.98] sm:text-[52px] lg:text-[60px]" data-id="element-627" data-mp="mzgcdcdmfpyy">
        {lead} <span className={tone === 'dark' ? 'text-gold' : 'text-gold-dark'} data-id="element-628" data-mp="d8lok3kq8ibe">{highlight}</span>
      </h2>
      {intro && <p className={`mx-auto mt-5 max-w-2xl text-base leading-relaxed sm:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-body'}`} data-id="element-629" data-mp="8ajvcptl72m7">
          {intro}
        </p>}
    </div>;
}